export const FETCH_PUBLISHER_ANALYTICS = 'FETCH_PUBLISHER_ANALYTICS'
export const FETCH_PUBLISHER_ANALYTICS_SUCCESS = `${FETCH_PUBLISHER_ANALYTICS}_SUCCESS`
export const FETCH_SYSTEM_CONNECTOR_ACTIVITY = 'FETCH_SYSTEM_CONNECTOR_ACTIVITY'
export const FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS = `${FETCH_SYSTEM_CONNECTOR_ACTIVITY}_SUCCESS`
export const FETCH_PUBLISHER_NOTIFICATION_LOGS = 'FETCH_PUBLISHER_NOTIFICATION_LOGS'
export const FETCH_PUBLISHER_NOTIFICATION_LOGS_SUCCESS = `${FETCH_PUBLISHER_NOTIFICATION_LOGS}_SUCCESS`

export const FETCH_PUBLISHER_NOTIFICATION = 'FETCH_PUBLISHER_NOTIFICATION'
export const FETCH_PUBLISHER_NOTIFICATION_SUCCESS = `${FETCH_PUBLISHER_NOTIFICATION}_SUCCESS`

export const RESET_CSV_URLS = 'RESET_CSV_URLS'
